/**
 * Test IDs for QA automation.
 */
export const testIds = {
  liveEventsTrackerDismiss: "live-events-tracker-dismiss",
} as const;
